<nz-page-header nzBackIcon [nzGhost]="false" (nzBack)="goHome()">
  <nz-page-header-title>
    {{ 'NEWS.NEWS' | translate }}
  </nz-page-header-title>
  <nz-page-header-content>
    <app-news-tile></app-news-tile>
  </nz-page-header-content>
</nz-page-header>
